module.exports = __webpack_public_path__ + "img/Tutorials-log.23a3bee6.png";